import { EstadoPago } from '@/shared/model/enumerations/estado-pago';

export interface IEventoPago {
  estado?: EstadoPago | null;
  observacion?: string | null;
  cvu?: number | null;
  fecha?: Date | null;
  activo?: boolean | null;
}

export class EventoPago implements IEventoPago {
  constructor(
    public estadoNomina?: EstadoPago | null,
    public observacion?: string | null,
    public cvu?: number | null,
    public fecha?: Date | null,
    public activo?: boolean | null
  ) {}

  static fromObject(data: IEventoPago): EventoPago {
    const eventoPago = new EventoPago();
    for (const [key, value] of Object.entries(data)) {
      eventoPago[key] = value;
    }
    return eventoPago;
  }
}
